import React from 'react';
import { Process } from '../../components/process/process';
import { useMinimalDistancesNew } from './minimal-distances-new-hook';
import { ProcessForm } from './minimal-distances-new-types';
import { TranslationKeys } from '../../enums';

export function MinimalDistancesNew() {
  const { steps } = useMinimalDistancesNew();

  return (
    <Process<ProcessForm>
      steps={steps}
      title="Založení zdroje - Minimální vzdálenosti"
      translationKey={TranslationKeys.MINIMAL_DISTANCES_NEW}
    />
  );
}
